import React from 'react';

const SvgCheckedIn: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="-6 -4 24 24" {...props}>
    <path
      d="M0 10.2422C0 13.4173 2.51677 16.0005 5.61028 16.0005C8.70379 16.0005 11.2206 13.4173 11.2206 10.2422V8.16088C11.2206
      7.30015 10.5342 6.5999 9.69048 6.5999C9.49133 6.5999 9.3012 6.6393 9.12653 6.71024C8.94955 6.04783 8.355 5.55924
      7.65038 5.55924C7.45123 5.55924 7.2611 5.59865 7.08643 5.66959C6.90945 5.00718 6.3149 4.51859 5.61028 4.51859C5.4315
      4.51859 5.25989 4.55033 5.10025 4.60809V1.88227C5.10025 1.02154 4.41386 0.321289 3.57018 0.321289C2.72649 0.321289
      2.0401 1.02154 2.0401 1.88227V5.64874C1.88046 5.59098 1.70886 5.55924 1.53008 5.55924C0.686392 5.55924 0 6.2595 0
      7.12023V10.2422ZM1.02005 7.12023C1.02005 6.83332 1.24885 6.5999 1.53008 6.5999C1.8113 6.5999 2.0401 6.83332 2.0401
      7.12023V10.7625H3.06015C3.06015 9.56035 3.06015 2.17435 3.06015 1.88227C3.06015 1.59536 3.28895 1.36194 3.57018
      1.36194C3.85141 1.36194 4.0802 1.59536 4.0802 1.88227V8.6812H5.10025V6.07957C5.10025 5.79266 5.32905 5.55924 5.61028
      5.55924C5.89151 5.55924 6.12031 5.79266 6.12031 6.07957V8.6812H7.14036V7.12023C7.14036 6.83332 7.36915 6.5999 7.65038
      6.5999C7.93161 6.5999 8.16041 6.83332 8.16041 7.12023V8.6812H9.18046V8.16088C9.18046 7.87397 9.40926 7.64055 9.69048
      7.64055C9.97171 7.64055 10.2005 7.87397 10.2005 8.16088V10.2422C10.2005 12.8435 8.14133 14.9598 5.61028 14.9598C3.07923
      14.9598 1.02005 12.8435 1.02005 10.2422V7.12023Z"
      fill="#373B40"
    />
    <path
      d="M6.97039 1.79494C6.75817 1.60972 6.43598 1.63162 6.25077 1.84384C6.06555 2.05607 6.08745 2.37825 6.29967 2.56347L7.8935
      3.95444C8.08563 4.12212 8.37208 4.12212 8.56422 3.95444L12.0706 0.894297C12.2829 0.709083 12.3048 0.386897 12.1195
      0.174673C11.9343 -0.0375505 11.6121 -0.0594467 11.3999 0.125767L8.22886 2.89324L6.97039 1.79494Z"
      fill="#FF6661"
    />
  </svg>
);

export default SvgCheckedIn;
